import React, { useState } from 'react';

import './Contact.css'
import contactStyles from './Contact.module.css';
import emailjs from 'emailjs-com';
import { init } from 'emailjs-com';

init("user_wjFCgZhCvSnoGLjRz1h3y");
const Contact = () => {

    const [showStatus, setShowStatus] = useState(false);
    const [pointerEvent, setPointerEvent] = useState({
        pointerEvents: 'none'
    })

    const [countLetters, setcountLetters] = useState(0);
    const [contactInfo, setContactInfo] = useState({
        name: '',
        email: '',
        message: ''
    })
    const [checkEmail, setCheckEmail] = useState({
        border: '1px solid transparent'
    })
    const displayWords = (event) => {
        setcountLetters(event.target.value.length);
    }

    const clearInputs = () => {
        const inputFields = document.getElementsByClassName(contactStyles.inputbox);
        // console.log(inputFields);
        // inputFields.forEach(element => {
        //     console.log(element.childNodes[0]);
        // });
        for (let item of inputFields) {
            item.firstChild.value = '';
        }
        // Changing state of a readonly input element
        setcountLetters(0);
    }
    const sendEmail = () => {
        // event.preventDefault();
        if (countLetters === 0) {
            alert("Please Write Something");
        }
        else {
            const formData = document.getElementsByClassName(contactStyles.contactForm)[0];
            emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, formData, process.env.REACT_APP_USER_ID)
                .then((result) => {
                    if (result.text === "OK") {
                        clearInputs();
                        setShowStatus(true);
                        setTimeout(() => {
                            setShowStatus(false);
                        }, 3100);
                    }
                }, (error) => {
                    // console.log(error.text);
                })

        }

    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (countLetters === 0) {
            alert("Please Write Something");
        }
        clearInputs();
        emailjs.sendForm("service_k429izx", 'template_be7yhwu', event.target, 'user_wjFCgZhCvSnoGLjRz1h3y')
            .then((result) => {
                console.log(result.text);
                setShowStatus(true);
                setTimeout(() => {
                    setShowStatus(false);
                }, 3100);
            }, (error) => {
                console.log(error.text);
            });

        event.target.reset();

    }
    const handleEmail = (event) => {
        let regx = /\S+@\S+\.\S+/;
        const newCheckEmail = { ...checkEmail }
        const newEvent = { ...pointerEvent }
        if (event.target.value !== '' && !regx.test(event.target.value)) {
            newCheckEmail.border = "3px solid rgba(145, 27, 29, 0.7)";
            newEvent.pointerEvents = 'none';
        }
        else {
            newCheckEmail.border = "2px solid transparent";
            newEvent.pointerEvents = 'auto';
        }
        setCheckEmail(newCheckEmail);
        setPointerEvent(newEvent);
    }
    const handleBlur = (event) => {
        const inputName = event.target.name;
        const newContactInfo = { ...contactInfo };
        newContactInfo[inputName] = event.target.value;
        setContactInfo(newContactInfo);
    }

    return (


        <div className="container mt-5  ms-auto me-auto mb-5 contact">
            {
                showStatus && alert("Message Succesfuly sent. Thank you")

            }
            <div className="row">
                <div className="col-12">
                    <h1 className="mainTextCol text-center  mb-3">Contact</h1>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Email address*</label>
                            <input style={checkEmail} onChange={handleEmail} onBlur={handleBlur} type="email" placeholder="Email"
                                className="form-control"
                                name="Email" required id={contactStyles.userEmail} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="Name"> Name*</label>
                            <input type="text" onBlur={handleBlur} className="form-control" placeholder="Name" name="name" required id={contactStyles.userName} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="Subject"> Subject</label>
                            <input type="text" className="form-control" name="subject"
                                placeholder="Subject(Optional)" />
                        </div>


                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1">Message*</label>
                            <textarea name="message" className="form-control" id={contactStyles.messageArea} onBlur={handleBlur} placeholder="Message" onChange={displayWords} rows="6"></textarea>
                        </div>

                        <div className={contactStyles.submitGrp}>
                            <div className={`${contactStyles.inputbox}`}>
                                <input type="text" value={countLetters} className={contactStyles.wordCount} disable />
                            </div>
                            <div style={pointerEvent} onClick={sendEmail}>
                                <button className="submit-btn">Submit</button>
                            </div>


                        </div>
                        <p style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                            <h6 style={{ color: 'aliceblue' }}>or email me directly:</h6>
                            <a className="changeanchor" href="mailto:mdkais3@gmail.com">  <h5 style={{ color: 'aqua', display: 'flex', wordBreak: 'break-word' }}>mdkais3@gmail.com</h5></a>
                        </p>


                    </form>
                </div>
            </div>
        </div>

    );
};

export default Contact;
